import { Component, Input } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { AuthService } from "app/auth/auth.service";
import { Events } from "ionic-angular";
import CollapsibleEvent from "models/events/collapsible-modal.event";
import { PlanOfCareHistoryReportPayload } from "models/patient-reports/plan-of-care-history";
import * as moment from "moment-timezone";
import { ReportExecutionService } from "providers/report-execution-service/report-execution.service";

@Component({
  selector: "plan-of-care-history",
  templateUrl: "plan-of-care-history.html",
})
export class PlanOfCareHistoryComponent {
  @Input()
  private patientChartId: number;

  private showPlanOfCareHistory: boolean = true;
  private reportForm: FormGroup;
  private isDeclined: boolean = null;
  private showRequiredMsg: boolean = false;

  public onCollapseClicked($e: CollapsibleEvent): void {
    this.showPlanOfCareHistory = !this.showPlanOfCareHistory;
  }

  constructor(
    private formBuilder: FormBuilder,
    private reportExecutionService: ReportExecutionService,
    private authSvc: AuthService,
    private events: Events
  ) {}

  ngOnInit() {
    this.reportForm = this.formBuilder.group({
      startDate: [null],
      endDate: [null],
    });
    this.events.publish("reloadNavBar");
  }

  public downloadReport(): void {
    if (this.checkRequiredField()) {
      this.showRequiredMsg = false;
      const user = this.authSvc.getUser();
      // const role = JSON.parse(user.profile.role);
      // const { orgID } = role[0];
      let startDate = moment(
        this.reportForm.controls["startDate"].value
      ).format("YYYY-MM-DD");
      let endDate = moment(this.reportForm.controls["endDate"].value).format(
        "YYYY-MM-DD"
      );
      let timeZone = this.getTimeZone();
      let reportPayload: PlanOfCareHistoryReportPayload = {
        pOrgID: user.tenantId.toString(),
        pPatientChartID: this.patientChartId.toString(),
        pStartDate: startDate,
        pEndDate: endDate,
        pActive: "false",
        pActiveResolved: "true",
        pDeclined: this.isDeclined.toString(),
        pTimeZone: timeZone,
      };
      this.reportExecutionService.downloadReport(
        "plan_of_care_history_pdf",
        reportPayload,
        this.reportExecutionService.buildReportFilename(
          "Plan_of_Care_History",
          "pdf"
        )
      );
    } else {
      this.showRequiredMsg = true;
    }
  }

  private getTimeZone(): string {
    let timeZone = moment.tz.guess();
    let time = new Date();
    return moment(time).tz(timeZone).format("z");
  }

  public toggleOption(option: boolean): void {
    this.isDeclined = option;
  }

  private checkRequiredField() {
    return (
      this.reportForm.controls["startDate"].value &&
      this.reportForm.controls["endDate"].value &&
      this.isDeclined !== null
    );
  }

  resetFields() {
    this.reportForm.controls["startDate"].setValue(null);
    this.reportForm.controls["endDate"].setValue(null);
    this.isDeclined = null;
    // Clear any lingering "filters required" validation message so the form
    // returns to a pristine state — otherwise the red error stays on screen
    // after the user has cleared the fields.
    this.showRequiredMsg = false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/patient-reports/reports/plan-of-care-history.ts